import { createAction, props } from '@ngrx/store';

const AUTH_RESET_ALL = '[AUTH][RESET]::[All]';
export const AUTH_SET_TOKEN = '[AUTH][SET]::[Token]';
export const AUTH_SET_INFO = '[AUTH][SET]::[Info]';

export const SetToken = createAction(
  AUTH_SET_TOKEN,
  props<{ token: string; ready: boolean }>()
);
export const SetInfo = createAction(
  AUTH_SET_INFO,
  props<{
    info: {
      first_name: string;
      last_name: string;
      role: string;
      avatar: string;
    };
  }>()
);
export const ResetAll = createAction(AUTH_RESET_ALL);
